import { Loader2, Brain, Sparkles } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface GlobalAnalysisLoaderProps {
  isVisible: boolean;
  currentStep: number;
  totalSteps: number;
  message: string;
}

export const GlobalAnalysisLoader = ({ 
  isVisible, 
  currentStep, 
  totalSteps, 
  message 
}: GlobalAnalysisLoaderProps) => {
  if (!isVisible) return null;
  
  const progress = (currentStep / totalSteps) * 100;
  
  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center">
      <div className="bg-background rounded-lg p-8 max-w-md w-full mx-4 space-y-6 border shadow-lg">
        <div className="flex items-center gap-3">
          <div className="relative">
            <Brain className="h-6 w-6 text-primary" />
            <Sparkles className="h-3 w-3 text-purple-600 absolute -top-1 -right-1 animate-pulse" />
          </div>
          <h3 className="text-lg font-semibold">Gerando Análise Global IA</h3>
        </div>
        
        <div className="space-y-2">
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>{message}</span>
            <span>{currentStep}/{totalSteps}</span>
          </div>
          <Progress value={progress} className="h-2" />
        </div>
      </div>
    </div>
  );
};
